/* eslint-disable
    block-scoped-var,
    guard-for-in,
    no-eval,
    no-multi-assign,
    no-nested-ternary,
    no-plusplus,
    no-restricted-syntax,
    no-return-assign,
    no-sequences,
    no-undef,
    no-use-before-define,
    no-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.directive('landscapeForm', ($rootScope, $location, $state, $stateParams, LandscapeQuestions, $sce, AlertManager, $timeout, $compile, BubblesService, LandscapeElements, ErrorCatcher, $uibModal) => ({
    restrict: 'E',
    replace: true,
    templateUrl: '/directives/landscape-form/landscape-form.html',
    scope: {
        questions: '=',
        contractSelected: '=',
    },
    link: {
        pre(scope, element, attrs) {
            let tmpNextQuestion = null

            scope.id_contract = scope.contractSelected.id
            scope.isDraft = true
            scope.heating = null
            scope.primary_residence = null
            scope.img_path = '/images/assets/img/landscape_form'
            scope.answers = scope.answers
            scope.questionsI = 0
            scope.disableBack = false
            scope.landscapeDone = false
            scope.currentStep = parseInt($stateParams.step, 10)
            scope.animTriggered = false
            scope.errors = []
            scope.answers = []
            scope.subscriptionStates = ['salesTunnel', 'newContract', 'salesTunnelV2', 'salesTunnelV3']
            scope.landscapeElements = (LandscapeElements.LandscapeElements = [])
            scope.bubbles = new BubblesService('#vis')



            scope.temperatureList = [
                {
                    tooltip: 'Économe',
                    value: 17,
                    color: '#455469',
                },
                {
                    tooltip: 'Normal',
                    value: 18,
                    color: '#455469',
                },
                {
                    tooltip: 'Confortable',
                    value: 19,
                    color: '#c2395c',
                },
                {
                    tooltip: 'Chaud',
                    value: 20,
                    color: '#c2395c',
                },
                {
                    tooltip: 'Plus chaud',
                    value: 21,
                    color: '#c2395c',
                },
            ]

            scope.steps = [
                {
                    label: 'C\'est parti !',
                    category: 'c-est-parti',
                    active: false,
                    done: false,
                    notify: true,
                    navigation: false,
                },
                {
                    label: 'Mon logement',
                    category: 'logement',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true,
                },
                {
                    label: 'Ma situation',
                    category: 'situation',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true,
                },
                {
                    label: 'Mon énergie',
                    category: 'energie',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true,
                },
                {
                    label: 'Mes équipements',
                    category: 'equipement',
                    active: false,
                    done: false,
                    notify: false,
                    show_progression: true,
                    navigation: true,
                },
            ]

            scope.$on('landscapeNavigating', () => scope.errors = [])



            const watchStep = (step) => (() => {
                const result = []
                for (let i = 0, end = scope.steps.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    let item
                    scope.steps[i].done = i < step
                    scope.steps[i].active = (i === step)
                    if (i === step) {
                        scope.steps[step].done = false
                        item = scope.steps[step].active = true
                    }
                    result.push(item)
                }
                return result
            })()

            scope.$watch('currentStep', watchStep, false)

            if ($stateParams.step && ($stateParams.step < scope.steps.length) && ($stateParams.step > 0)) {
                scope.currentStep = parseInt($stateParams.step, 10)
            } else if (!scope.questions || ((scope.questions.length === 1) && (scope.questions[0][0].id === 1))) {
                scope.currentStep = 0
            } else {
                scope.currentStep = 1
            }

            angular.forEach(scope.steps, (value, index) => {
                if (scope.currentStep > parseInt(index, 10)) {
                    value.done = true
                }

                if (parseInt(index, 10) === scope.currentStep) {
                    return value.active = true
                }
            })

            scope.toInt = (value) => parseInt(value, 10)

            scope.printLabel = function (question, qBlock) {
                // specific to question 6
                let html
                let label

                if ((question.label.indexOf('{') > -1) && (question.label.indexOf('}') > -1)) {
                    label = question.label.slice(1)
                    label = label.slice(0, label.length - 1)
                    try {
                        const qJ = JSON.parse(label)
                        let prevQ = null
                        for (let i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            const block = scope.questions[i]
                            if (block === qBlock) {
                                prevQ = scope.questions[i - 1]
                            }
                        }

                        const numberOfOccupiants = scope.answers[prevQ[1].id].value
                        html = qJ.singular
                        if (parseInt(numberOfOccupiants, 10) > 1) {
                            html = qJ.plural
                        }
                        html = html.replace('%d', numberOfOccupiants)
                        return $sce.trustAsHtml(html)
                    } catch (error) {
                        return label
                    }
                } else {
                    html = question.label
                    return $sce.trustAsHtml(html)
                }
            }

            scope.checkChangeNumber = function (answer, question) {
                if (answer) {
                    if (parseInt(answer.value, 10) > parseInt(eval(question.max), 10)) {
                        return answer.value = parseInt(eval(question.max), 10)
                    } else if (parseInt(answer.value, 10) < parseInt(eval(question.min), 10)) {
                        return answer.value = parseInt(eval(question.min), 10)
                    }
                }
            }

            scope.templateLiteral = (expression) => eval(expression)

            scope.easterEgg = function () {
                const elem = document.getElementById('hanger-right')
                elem.style.display = 'none'

                const hL = document.getElementById('hanger-left')
                const formContainer = document.getElementById('form-container')

                if (hL) {
                    hL.className += ' cut-it'

                    formContainer.style.transform = 'rotate(15deg)'
                    return formContainer.className += ' bounceRotate'
                }
            }

            scope.getNextQuestion = function (question) {
                if (question) {
                    if (question.next) {
                        return question.next
                    } else if (question.answer_type === 'enum') {
                        for (let i = 0, end = question.enums.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            if (question.answer === question.enums[i].value) {
                                if (question.enums[i].next) { return question.enums[i].next }
                            }
                        }
                    }
                }

                return null
            }

            scope.isValid = function (answer, q) {
                if (q.answer_type !== 'enum') {
                    answer.answer_func = answer.value
                }
                let hasErr = false
                const qBlock = scope.getQuestionBlockById(q.id)
                if (qBlock) {
                    const l = scope.getQlength(qBlock)
                    return (() => {
                        const result = []
                        for (let i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            let item
                            if (!hasErr) {
                                if (qBlock[i].answer_type === 'number') {
                                    if (scope.answers[qBlock[i].id] && scope.answers[qBlock[i].id].value && (scope.answers[qBlock[i].id].value !== '')) {
                                        if (i === (l - 1)) {
                                            scope.errors = []
                                        }
                                    } else {
                                        hasErr = true
                                    }

                                    item = scope.checkChangeNumber(scope.answers[qBlock[i].id], q)
                                } else if (scope.answers[qBlock[i].id] && scope.answers[qBlock[i].id].value && (scope.answers[qBlock[i].id].value !== '')) {
                                    if (i === (l - 1)) {
                                        item = scope.errors = []
                                    }
                                } else {
                                    item = hasErr = true
                                }
                            }
                            result.push(item)
                        }
                        return result
                    })()
                }
            }

            scope.getQuestionById = function (id_question) {
                for (let i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    for (let it = 0, end1 = scope.getQlength(scope.questions[i]), asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                        if (scope.questions[i][it].id === id_question) {
                            return scope.questions[i][it]
                        }
                    }
                }
            }

            scope.getQuestionBlockById = function (id_question) {
                for (let i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    for (let it = 0, end1 = scope.getQlength(scope.questions[i]), asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                        if (scope.questions[i][it].id === id_question) {
                            return scope.questions[i]
                        }
                    }
                }
            }

            const validateQuestion = function (question, l, source, index) {
                let counter = 0
                let hasError = 0

                for (let i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    var it
                    if ((question[i].answer_type !== 'equipment') && (question[i].answer_type !== 'multi')) {
                        if (scope.answers[question[i].id] && scope.answers[question[i].id].value && !hasError) {
                            scope.errors = []
                            counter++
                        } else if (!scope.errors.length) {
                            if (source === 'keydown') {
                                scope.$apply(() => scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' }))
                            } else {
                                scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' })
                            }

                            hasError++
                        }
                    } else if ((question[i].answer_type === 'equipment') && question[i].exclusive) {
                        if (scope.answers[question[i].id] && ((scope.answers[question[i].id].length > 0) || (Object.keys(scope.answers[question[i].id]).length > 0))) {
                            scope.errors = []
                            counter++
                        } else {
                            if (source === 'keydown') {
                                scope.$apply(() => scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' }))
                            } else {
                                scope.errors.push({ message: 'Vous devez répondre à cette question avant de passer à la suivante.' })
                            }

                            hasError++
                        }
                    } else if (question[i].answer_type === 'multi') {
                        const multiObj = {}
                        const prevQ = scope.questions[index - 1][1]
                        let totalP = 0
                        for (it = 0, end1 = question[i].multi.length, asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                            var asc1
                            var end1
                            if (question[i].multi[i] && question[i].multi[it].index) {
                                if (question[i].multi[it].value) {
                                    totalP += parseInt(question[i].multi[it].value, 10)
                                    multiObj[question[i].multi[it].index] = question[i].multi[it].value
                                }
                            }
                        }

                        if ((totalP > parseInt(scope.answers[prevQ.id].value, 10)) || (totalP < parseInt(scope.answers[prevQ.id].value, 10))) {
                            scope.errors = []
                            scope.errors.push({ message: `Le total doit être égal au nombre d'occupants (${scope.answers[prevQ.id].value}).` })
                        } else {
                            scope.errors = []
                            scope.answers[question[i].id] = scope.answers[question[i].id] || {}
                            scope.answers[question[i].id].value = JSON.stringify(multiObj)
                        }
                        return scope.errors.length < 1
                    } else {
                        for (it = 0, end2 = question[i].enums.length, asc2 = end2 >= 0; asc2 ? it < end2 : it > end2; asc2 ? it++ : it--) {
                            var asc2
                            var end2

                            if (!question[i].popup_error) {
                                scope.popupHasError(question[i].enums[it].popup, question[i], question[i].enums[it].id_equipment)
                            }
                        }

                        if (question[i].popup_error) {
                            scope.errors.push({ message: 'Veuillez corriger les erreurs.' })
                        } else {
                            scope.errors = []
                            counter++
                        }
                    }
                }

                if (counter === l) {
                    return true
                }
                return false
            }

            scope.getInfoBulleTemplate = function (question) {
                const html = `<div>${question.info_bulle}</div>`
                return html
            }

            scope.nextStep = function (currentStep, cat, notify) {
                let newStep = currentStep + 1
                if (newStep > scope.steps.length) {
                    newStep = scope.steps.length - 1
                }
                scope.currentStep = newStep
                return scope.loaded = 1
            }

            // move to previous step from step arg
            scope.previousStep = function (currentStep, cat) {
                const previousStep = scope.steps[currentStep - 1]
                if (currentStep > 0) {
                    if (previousStep.notify) {
                        return $state.go($state.current, { step: currentStep - 1, cat }, { notify: previousStep.notify, resolve: true })
                    }
                    if (previousStep.category === cat) {
                        scope.currentStep = currentStep - 1
                        return $state.go($state.current, { step: currentStep - 1, cat }, { notify: previousStep.notify, resolve: false })
                    }
                }
            }

            // move to specific step, arg = step number
            scope.goToStep = function (step, cat) {
                if (step !== undefined) {
                    if ((step !== 0) && scope.questions.length) {
                        scope.currentStep = step
                        return $state.go($state.current, { step, cat, resolve: false }, { notify: false })
                    }
                    scope.currentStep = step
                    return $state.go($state.current, { step, cat, resolve: false }, { notify: false })
                }
            }

            scope.navToStep = function (step, cat) {
                if (scope.steps[step].navigation) {
                    let l
                    return __range__(scope.questions.length - 1, 0, false).map((i) => ((l = scope.getQlength(scope.questions[i])), (() => {
                        const result = []
                        for (let it = 0, end = l, asc = end >= 0; asc ? it < end : it > end; asc ? it++ : it--) {
                            let item
                            if (scope.questions[i][it].category === cat) {
                                item = scope.goToQ(i)
                            }
                            result.push(item)
                        }
                        return result
                    })()))
                }
            }

            // set progression bar
            scope.setProgression = (currentStep) => ({ width: `${currentStep * 20}%` })

            // set width for sliding effect
            scope.setQuestionsWidth = function () {
                if (scope.questions) {
                    return { width: `${435 * scope.questions.length}px` }
                }
            }

            // submit Q
            scope.validateQ = function (index, source) {
                scope.disableSave = true
                const question = scope.questions[index]
                // const qDomId = `step${scope.currentStep}-q${index}`
                // object to pass by reference
                const validatedQ = { v: 0 }
                const l = scope.getQlength(question)
                let tmpStatus
                if (validateQuestion(question, l, source, index)) {
                    tmpNextQuestion = null
                    const handleQuestion = function (questionIndex, callback) {
                        if (questionIndex < l) {
                            const q = question[questionIndex]
                            const nextQ = scope.questions[index + 1]
                            let status = scope.getAnswerStatus(q, scope.answers[q.id], nextQ)
                            if ((tmpStatus !== 1) && (tmpStatus !== undefined)) {
                                status = tmpStatus === 2 ? 2 : 3
                            }

                            tmpStatus = status
                            // if answer exists and not changed
                            if (status === 1) {
                                // if next question exists
                                if (scope.questions[index + 1] && (validatedQ.v >= l)) {
                                    return scope.nextQ(question, scope.questions[index + 1], index)
                                } else if (scope.questions[index + 1] && (scope.questions[index + 1].length > 0)) {
                                    validatedQ.v++
                                    if ((validatedQ.v >= l) && (scope.questions[index + 1] !== undefined)) {
                                        scope.disableSave = false
                                        return scope.nextQ(question, scope.questions[index + 1], index)
                                    }
                                    scope.disableSave = false
                                    return callback(questionIndex + 1, callback)
                                }
                                return scope.saveAnswer(q, question, index, validatedQ, l, (nextQuestion) => {
                                    if (validatedQ.v < l) {
                                        return callback(questionIndex + 1, callback)
                                    } else if (nextQuestion && (nextQuestion.length > 0)) {
                                        scope.disableSave = false
                                        return scope.nextQ(question, nextQuestion, index)
                                    } else if (q.last) {
                                        scope.disableSave = false
                                        return scope.setLandscapeDone()
                                    }
                                })
                            // if answer exists but different from original
                            } else if (status === 2) {
                                // clean all answers after the current one
                                if (index === 0) {
                                    return LandscapeQuestions.flush({ id_contract: scope.id_contract, draft: scope.isDraft }).$promise
                                    .then(((data) => {
                                        scope.flush()
                                        return scope.saveAnswer(q, question, index, validatedQ, l, (nextQuestion) => {
                                            if (validatedQ.v < l) {
                                                callback(questionIndex + 1, callback)
                                            }
                                            if (nextQuestion && (nextQuestion.length > 0)) {
                                                scope.disableSave = false
                                                return scope.nextQ(question, nextQuestion, index)
                                            } else if (q.last) {
                                                scope.disableSave = false
                                                return scope.setLandscapeDone()
                                            }
                                        })
                                    }), ((response) => {}))
                                    .catch((error) => {
                                        console.error('catchError', error)
                                        AlertManager.error('Une erreur est survenue, veuillez réessayer plus tard.')
                                        callback(i++, callback)
                                        return ErrorCatcher.catchError(error)
                                    })
                                }
                                if (q.flush_after) {
                                    return LandscapeQuestions.flushAfter({ id_question: q.id, id_contract: scope.id_contract, draft: scope.isDraft }).$promise
                                    .then((data) => {
                                        const cb = () => scope.saveAnswer(q, question, index, validatedQ, l, (nextQuestion) => {
                                            if (validatedQ.v < l) {
                                                return callback(questionIndex + 1, callback)
                                            } else if (nextQuestion && (nextQuestion.length > 0)) {
                                                scope.disableSave = false
                                                return scope.nextQ(question, nextQuestion, index)
                                            } else if (q.last) {
                                                scope.disableSave = false
                                                return scope.setLandscapeDone()
                                            }
                                        })

                                        return scope.flushAfter(question[0].id, cb)
                                    })
                                    .catch(ErrorCatcher.catchError)
                                }
                                return scope.saveAnswer(q, question, index, validatedQ, l, (nextQuestion) => {
                                    if (validatedQ.v < l) {
                                        return callback(questionIndex + 1, callback)
                                    } else if (nextQuestion && (nextQuestion.length > 0)) {
                                        scope.disableSave = false
                                        return scope.nextQ(question, nextQuestion, index)
                                    } else if (q.last) {
                                        scope.disableSave = false
                                        return scope.setLandscapeDone()
                                    }
                                })
                            // if answer does not exists
                            } else if (status === 3) {
                                return scope.saveAnswer(q, question, index, validatedQ, l, (nextQuestion) => {
                                    if (validatedQ.v < l) {
                                        return callback(questionIndex + 1, callback)
                                    } else if (nextQuestion && (nextQuestion.length > 0)) {
                                        scope.disableSave = false
                                        return scope.nextQ(question, nextQuestion, index)
                                    } else if (q.last) {
                                        scope.disableSave = false
                                        return scope.setLandscapeDone()
                                    }
                                })
                            }
                        }
                    }

                    return handleQuestion(0, handleQuestion)
                }
                return scope.disableSave = false
            }

            scope.getAnswerStatus = function (q, a, nextQ) {
                // if exists and not changed : 1
                if (q) {
                    if ((q.answer_type === 'equipment') && q.answer) {
                        let qA
                        if (typeof q.answer === 'string') {
                            qA = q.answer.split(',')
                        } else {
                            qA = [q.answer]
                        }
                        // if exists and not changed : 1
                        if ((scope.answers[q.id] != null) && a && (a.length > 0) && (qA.length > 0) && (qA === a) && nextQ) {
                            return 1
                        // if exists but diff : 2
                        } else if ((qA.length > 0) && a && (a.length > 0) && (qA !== a)) {
                            return 2
                        }
                        // if not exists : 3
                        return 3
                    }
                    if ((a != null) && (a.value != null) && (q.answer != null) && (q.answer === a.value) && nextQ) {
                        return 1
                    } else if ((q.answer != null) && (a != null) && (q.answer !== a.value)) {
                        return 2
                    }
                    return 3
                }
            }

            scope.editForm = () => scope.$evalAsync(() => {
                scope.animTriggered = true
                const elem = document.getElementById('form-container')
                const vis = document.getElementById('vis')
                const landCanvas = document.getElementById('landscape-canvas')
                if (elem && vis && landCanvas) {
                    elem.className = elem.className.replace('get-out', '')
                    landCanvas.className = landCanvas.className.replace(' get-in-middle', '')
                    return vis.className = vis.className.replace('fade-out', '')
                }
            })

            scope.hasNextQuestion = function (question) {
                let hasNext = true
                const qLength = scope.getQlength(question)
                for (let i = 0, end = qLength, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    const q = question[i]
                    if (!scope.getNextQuestion(q) && q.last) {
                        hasNext = false
                    }
                }

                return hasNext
            }

            scope.saveAnswer = function (q, question, index, validatedQ, l, callback) {
                scope.disableSave = true
                const answer = {
                    id_question: q.id,
                }
                // answer is equipment
                if (scope.answers[q.id] && (q.answer_type === 'equipment')) {
                    const tempA = []
                    const tempFuncA = []
                    for (const key in scope.answers[q.id]) {
                        if (scope.answers[q.id][key] && scope.answers[q.id][key].value) {
                            if (key !== 'popups') {
                                tempA.push(key.toString())
                                tempFuncA.push(scope.answers[q.id][key].answer_func)
                            }
                        }
                    }
                    answer.answer = tempA.join()
                    answer.answer_func = tempFuncA.join()
                } else if (scope.answers[q.id]) {
                    answer.answer = scope.answers[q.id].value
                    answer.answer_func = scope.answers[q.id].answer_func || null
                } else if (!scope.answers[q.id] && (q.answer_type === 'equipment')) {
                    answer.answer = ''
                }

                if (scope.answers[q.id] && scope.answers[q.id].popups) {
                    answer.popups = scope.answers[q.id].popups
                }

                if (answer.answer || (q.answer_type === 'equipment')) {
                    return LandscapeQuestions.saveAnswer({ id_contract: scope.id_contract, draft: scope.isDraft }, answer).$promise
                    .then(((data) => {
                        if (data) {
                            if (q.answer_type !== 'equipment') {
                                scope.setQuestionAnswer(data, index)
                            }

                            validatedQ.v++

                            if (data.heating) {
                                scope.heating = data.heating
                                if (scope.contractSelected) {
                                    scope.contractSelected.heating = data.heating
                                }
                            }
                            if (_.isBoolean(data.primary_residence)) {
                                scope.primary_residence = data.primary_residence
                                if (scope.contractSelected) {
                                    scope.contractSelected.primary_residence = data.primary_residence
                                }
                            }
                            if (data.next_question && (data.next_question.length > 0)) {
                                tmpNextQuestion = data.next_question
                                if (!scope.getQuestionById(data.next_question[0].id)) {
                                    scope.questions.push(data.next_question)
                                }

                                return callback(data.next_question)
                            } else if (tmpNextQuestion) {
                                if (!scope.getQuestionById(tmpNextQuestion[0].id)) {
                                    scope.questions.push(tmpNextQuestion)
                                }

                                return callback(tmpNextQuestion)
                            } else if (validatedQ.v === l) {
                                // do form submitted
                                return callback(null)
                            }
                        } else {
                            return AlertManager.error('Une erreur est survenue, veuillez réessayer plus tard.')
                        }
                    }), ((response) => {
                        if ((response.statusCode < 200) || (response.statusCode > 299)) {
                            return AlertManager.error('Une erreur est survenue, veuillez réessayer plus tard.')
                        }
                    })).catch(ErrorCatcher.catchError)
                }
                return AlertManager.error('Une erreur est survenue, veuillez réessayer plus tard.')
            }

            scope.findLandscapeElement = function (id_question) {
                for (let i = 0, end = scope.landscapeElements.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    if (scope.landscapeElements[i] && (scope.landscapeElements[i].id_question === id_question)) { return { element: scope.landscapeElements[i], i } }
                }
            }

            scope.findLandscapeEquipments = function (elem) {
                for (let i = 0, end = scope.landscapeEquipments.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    if (scope.landscapeEquipments[i].pictofont === elem.pictofont) {
                        scope.landscapeEquipments[i].i = i
                        return scope.landscapeEquipments[i]
                    }
                }

                return null
            }

            scope.setLandscapeElement = function (question, answer) {
                if (question) {
                    let i
                    let img
                    const lE = scope.findLandscapeElement(question.id)

                    if (answer && (answer.answer_type !== 'equipment')) {
                        if ((question.answer_type === 'enum') && answer) {
                            return (() => {
                                const result = []
                                for (i = 0, end = question.enums.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                                    var asc
                                    var end
                                    let item
                                    if (question.enums[i].value === answer) {
                                        // should chek if not already in for update
                                        if (question.enums[i].landscape) {
                                            if (question.enums[i].replace && lE && scope.landscapeElements[lE.i - 1]) {
                                                scope.landscapeElements[lE.i - 1].img = null
                                                item = scope.landscapeElements[lE.i] = { img: `/images/assets/img/landscape/${question.enums[i].landscape}`, id_question: question.id }
                                            } else if (lE) {
                                                item = scope.landscapeElements[lE.i] = { img: `/images/assets/img/landscape/${question.enums[i].landscape}`, id_question: question.id }
                                            } else if (!lE) {
                                                item = scope.landscapeElements.push({ img: `/images/assets/img/landscape/${question.enums[i].landscape}`, id_question: question.id })
                                            }
                                        } else if (lE) {
                                            item = scope.landscapeElements[lE.i] = { img: null, id_question: question.id }
                                        }
                                    }
                                    result.push(item)
                                }
                                return result
                            })()
                        } else if (question.landscape_it && question.landscape && (question.landscape !== '0')) {
                            img = `/images/assets/img/landscape/${eval(question.landscape)}`
                            if (answer === 0) {
                                return scope.landscapeElements[lE.i] = { img: null, id_question: question.id }
                            } else if (lE) {
                                return scope.landscapeElements[lE.i] = { img, id_question: question.id }
                            } else if (!lE) {
                                return scope.landscapeElements.push({ img, id_question: question.id })
                            }
                        }
                    } else if (!answer && lE) {
                        return scope.landscapeElements[lE.i] = { img: null, id_question: question.id }
                    }
                }
            }

            scope.setQuestionAnswer = function (answer, index) {
                if (scope.questions[index]) {
                    const l = scope.getQlength(scope.questions[index])
                    return (() => {
                        const result = []
                        for (let i = 0, end = l, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                            let item
                            if (scope.questions[index][i].id === answer.id_question) {
                                scope.questions[index][i].id_answer = answer.id
                                switch (scope.questions[index][i].answer_type) {
                                    case 'number': item = scope.questions[index][i].answer = parseInt(answer.answer, 10); break
                                    default: item = scope.questions[index][i].answer = answer.answer
                                }
                            }
                            result.push(item)
                        }
                        return result
                    })()
                }
            }

            scope.flush = function () {
                // reverse loop because splice reorganises array
                for (let start = scope.questions.length - 1, i = start, asc = start <= 0; asc ? i < 0 : i > 0; asc ? i++ : i--) {
                    if (scope.questions[i]) {
                        scope.questions.splice(i, 1)
                        scope.deleteQstyle(i)
                    }
                }

                return scope.bubbles.flush()
            }

            scope.flushAfter = function (idQuestion, callback) {
                for (let start = scope.questions.length - 1, i = start, asc = start <= 0; asc ? i < 0 : i > 0; asc ? i++ : i--) {
                    for (let it = 0, end = scope.getQlength(scope.questions[i]), asc1 = end >= 0; asc1 ? it < end : it > end; asc1 ? it++ : it--) {
                        if (scope.questions[i] && scope.questions[i][it]) {
                            if (scope.questions[i][it].id === idQuestion) {
                                return callback()
                            } else if (scope.questions[i][it].id > idQuestion) {
                                scope.questions.splice(i, 1)
                                scope.deleteQstyle(i)
                            }
                        }
                    }
                }
            }

            scope.setMultiClass = function (q) {
                if (q.multi.length <= 3) {
                    return 'col-xs-4'
                }
                return `col-xs-${Math.round(12 / q.multi.length)}`
            }

            scope.setMultiAnswer = function (q, multi, index) {
                const multiObj = {}
                const prevQ = scope.questions[index - 1][1]
                let totalP = 0
                for (let i = 0, end = q.multi.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    if (q.multi[i] && q.multi[i].index) {
                        if (q.multi[i].value) {
                            totalP += parseInt(q.multi[i].value, 10)
                            multiObj[q.multi[i].index] = q.multi[i].value
                        }
                    }
                }

                if ((totalP > parseInt(scope.answers[prevQ.id].value, 10)) || (totalP < parseInt(scope.answers[prevQ.id].value, 10))) {
                    return null
                }
                scope.errors = []
                scope.answers[q.id] = scope.answers[q.id] || {}
                return scope.answers[q.id].value = JSON.stringify(multiObj)
            }

            // move to previous Q in same category
            scope.previousQ = function (index) {
                if (!scope.disableBack) {
                    $rootScope.$broadcast('landscapeNavigating')

                    if (scope.questionsI > 1) {
                        const question = scope.questions[index - 1]
                        if (question) {
                            let elem
                            let qDomId

                            if (question[0].category !== scope.steps[scope.currentStep].category) {
                                qDomId = `step1-q${index - 1}`
                                elem = document.getElementById(qDomId)
                                elem.style.marginLeft = '0'
                                scope.disableBack = true
                                $timeout(() => {
                                    scope.questionsI = index
                                    return scope.disableBack = false
                                }, 300)

                                return scope.previousStep(scope.currentStep, question[0].category)
                            }
                            qDomId = `step1-q${index - 1}`
                            elem = document.getElementById(qDomId)
                            elem.style.marginLeft = '0'
                            scope.disableBack = true
                            return $timeout(() => {
                                scope.questionsI = index
                                return scope.disableBack = false
                            }, 300)
                        }
                    }
                }
            }

            scope.getCurrentStep = function (question) {
                let category = ''
                if (question.category) {
                    ({ category } = question)
                } else if (question && (scope.getQlength(question) > 0)) {
                    ({ category } = question[0])
                }

                for (let i = 0, end = scope.steps.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    const step = scope.steps[i]
                    if (step.category === category) {
                        return i
                    }
                }
            }

            scope.nextQ = function (question, next_question, index) {
                let elem
                let formEl
                let formElStyle
                let mLeft
                $rootScope.$broadcast('landscapeNavigating')
                const qDomId = `step1-q${index}`
                const currentStep = scope.getCurrentStep(question)

                if ((next_question[0].category === question[0].category) || (next_question[0].category === question.category)) {
                    elem = document.getElementById(qDomId)
                    formEl = document.getElementById('form-container')
                    formElStyle = window.getComputedStyle(formEl)
                    mLeft = formElStyle.width

                    if (elem) {
                        elem.style.marginLeft = `-${mLeft}`
                        scope.disableBack = true
                        return $timeout(() => {
                            scope.questionsI = index + 2
                            return scope.disableBack = false
                        }, 300)
                    }
                } else if (currentStep < 4) {
                    elem = document.getElementById(qDomId)
                    formEl = document.getElementById('form-container')
                    formElStyle = window.getComputedStyle(formEl)
                    mLeft = formElStyle.width

                    if (elem) {
                        elem.style.marginLeft = `-${mLeft}`
                        scope.disableBack = true
                        $timeout(() => {
                            scope.questionsI = index + 2
                            return scope.disableBack = false
                        }, 300)

                        return scope.nextStep(scope.currentStep, next_question[0].category, { notify: false, resolve: false })
                    }
                }
            }

            scope.getQlength = function (q) {
                if (q) {
                    let l
                    if (!q.length) {
                        l = Object.keys(q).length
                    } else {
                        l = q.length
                    }

                    return l
                }
            }

            return scope.getAnswerFormatRaw = function (answer_format) {
                const res = eval(answer_format)
                if (res) {
                    return $sce.trustAsHtml(res)
                }
                return ''
            }
        },

        post(scope, element, attrs) {
            scope.qStyles = {}

            // go to Question (id_question)
            scope.goToQ = function (index) {
                let i
                const cat = scope.questions[index][0].category

                for (i = 0, end = scope.steps.length, asc = end >= 0; asc ? i <= end : i >= end; asc ? i++ : i--) {
                    var asc
                    var end

                    if (scope.steps[i] && (scope.steps[i].category === cat)) {
                        scope.goToStep(i, cat)
                    }
                }

                scope.questionsI = index + 1
                return scope.$applyAsync(() => (() => {
                    const result = []
                    for (i = 0, end1 = scope.questions.length, asc1 = end1 >= 0; asc1 ? i < end1 : i > end1; asc1 ? i++ : i--) {
                        var asc1
                        var end1
                        var domId
                        var questionsDomElem
                        var width

                        if (i < index) {
                            questionsDomElem = $('#questions')
                            width = questionsDomElem.innerWidth() - 30
                            domId = `step1-q${i}`
                            result.push(scope.qStyles[domId] = {
                                'margin-left': '-100%',
                                'width': `${width}px`,
                            })
                        } else {
                            questionsDomElem = $('#questions')
                            width = questionsDomElem.innerWidth() - 30
                            domId = `step1-q${i}`
                            result.push(scope.qStyles[domId] = {
                                'margin-left': '0',
                                'width': `${width}px`,
                            })
                        }
                    }
                    return result
                })())
            }

            scope.setQstyle = function (domId) {
                const isMobile = false
                const mobileAdjustment = scope.subscriptionStates.indexOf($state.current.name) > -1 ? 80 : 30
                const max = isMobile ? 239 : 434
                const adjustment = isMobile ? mobileAdjustment : 30

                if (scope.qStyles[domId] && (parseInt(scope.qStyles[domId].width.replace('px', ''), 10) > max)) {
                    return scope.qStyles[domId]
                }

                const questionsDomElem = $('#questions')
                const width = Math.max(max + 1, questionsDomElem.innerWidth() - adjustment)
                const style = { width: `${width}px` }
                scope.qStyles[domId] = style
                return style
            }

            scope.deleteQstyle = function (index) {
                const domId = `step1-q${index}`
                return delete scope.qStyles[domId]
            }

            scope.setEnumClass = function (enums, first) {
                let cssClass
                let s
                const isMobile = false

                if (enums.length > 4) {
                    if (enums.length === 6) {
                        let enumsClass
                        if (isMobile) {
                            s = 4
                            enumsClass = 'enums-long-mobile'
                        } else {
                            s = Math.floor(12 / enums.length)
                            enumsClass = 'enums-long'
                        }
                        cssClass = `${enumsClass} col-xs-${s} col-md-${s}`
                    } else {
                        s = Math.floor(12 / (enums.length / 2))
                        cssClass = `col-xs-${s} col-md-${s}`
                    }
                } else if (enums.length < 3) {
                    s = Math.floor(8 / enums.length)
                    const sM = 6
                    cssClass = `col-xs-${sM} col-md-${s}`
                    if (enums[0].img) {
                        cssClass += ' col-md-offset-1'
                    }
                } else {
                    s = Math.floor(12 / enums.length)
                    cssClass = `col-xs-${s} col-md-${s}`
                }

                if (enums[0].img) {
                    cssClass += ' img'
                } else if (first && (enums.length <= 4)) {
                    cssClass += ' col-md-offset-2'
                }

                return cssClass
            }

            scope.setEnumAnswer = function (answer, value, answer_func, question) {
                if (scope.answers[question.id] && question.popup) {
                    scope.answers[question.id].value = value
                    scope.answers[question.id].answer_func = answer_func
                } else {
                    scope.answers[question.id] = { value, answer_func }
                }
                return scope.isValid(answer, question)
            }

            scope.setEquipmentAnswer = function (answer, equipment, question) {
                const id_question = question.id
                if (scope.answers[id_question]) {
                    if (question.exclusive) {
                        scope.flushEquipmentsForQuestion(question)
                        scope.answers[id_question] = []
                    }

                    if (!scope.answers[id_question][equipment.id_equipment]) {
                        scope.answers[id_question][equipment.id_equipment] = {
                            value: true,
                            id_question,
                            pictofont: equipment.pictofont,
                            id_equipment: equipment.id_equipment,
                            answer_func: equipment.answer_func,
                        }
                        scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment])
                    } else {
                        const val = !scope.answers[id_question][equipment.id_equipment].value
                        scope.answers[id_question][equipment.id_equipment] = {
                            value: val,
                            id_question,
                            pictofont: equipment.pictofont,
                            id_equipment: equipment.id_equipment,
                            answer_func: equipment.answer_func,
                        }
                        scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment])
                    }
                } else if (!scope.answers[id_question]) {
                    scope.answers[id_question] = []
                    scope.answers[id_question][equipment.id_equipment] = {
                        value: true,
                        id_question,
                        pictofont: equipment.pictofont,
                        id_equipment: equipment.id_equipment,
                        answer_func: equipment.answer_func,
                    }
                    scope.setLandscapeEquipment(question, scope.answers[id_question][equipment.id_equipment])
                }

                if ((equipment.popup.length > 0) && scope.answers[id_question][equipment.id_equipment] && scope.answers[id_question][equipment.id_equipment].value) {
                    scope.popUp(equipment.popup, id_question)
                }

                return scope.answers[id_question][equipment.id_equipment]
            }

            scope.flushEquipmentsForQuestion = function (question) {
                for (let i = 0, end = scope.answers[question.id].length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                    if (scope.answers[question.id][i]) {
                        scope.bubbles.remove(scope.answers[question.id][i].pictofont)
                    }
                }
            }

            scope.popUp = function (id_question, id_trigger) {
                if (!scope.popuping) {
                    scope.popQuestions = []
                    scope.popuping = true
                    scope.answers[id_trigger].popups = scope.answers[id_trigger].popups || []

                    if (typeof id_question === 'object') {
                        return __range__(0, id_question.length, false).map((i) => {
                            return LandscapeQuestions.getPopupQuestion({ id_question: id_question[i] }).$promise
                            .then(((data) => {
                                if (data) {
                                    scope.popQuestions.push(data)
                                    scope.answers[data.id] = scope.answers[data.id] || {}
                                    scope.answers[id_trigger].popups[data.id] = scope.answers[data.id]
                                }

                                if (scope.popQuestions.length === id_question.length) {
                                    if (scope.popQuestions.length > 1) {
                                        scope.popupLarge = true
                                    } else {
                                        scope.popupLarge = false
                                    }
                                    scope.popup = true
                                    return scope.popuping = false
                                }
                            }), ((response) => {}))
                            .catch(ErrorCatcher.catchError)
                        })
                    }

                    return LandscapeQuestions.getPopupQuestion({ id_question }).$promise
                    .then(((data) => {
                        if (data) {
                            scope.popQuestions.push(data)
                            scope.answers[data.id] = scope.answers[data.id] || {}
                            scope.answers[id_trigger].popups[data.id] = scope.answers[data.id]
                            if (scope.popQuestions.length > 1) {
                                scope.popupLarge = true
                            } else {
                                scope.popupLarge = false
                            }
                            scope.popup = true
                            return scope.popuping = false
                        }
                    }), ((response) => {}))
                    .catch(ErrorCatcher.catchError)
                }
            }

            scope.popupIsAnswered = function (id_question, q, id_equipment) {
                const id_trigger = q.id
                if (scope.answers[id_trigger] && (scope.answers[id_trigger].value || (scope.answers[id_trigger][id_equipment] && scope.answers[id_trigger][id_equipment].value))) {
                    for (let i = 0, end = id_question.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        if (scope.answers[id_question[i]] && scope.answers[id_question[i]].value) {
                            return true
                        }
                    }
                }
            }

            scope.popupHasError = function (id_question, q, id_equipment) {
                const id_trigger = q.id
                if (scope.answers[id_trigger] && scope.answers[id_trigger][id_equipment] && scope.answers[id_trigger][id_equipment].value) {
                    for (let i = 0, end = id_question.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        if (!scope.answers[id_question[i]] || !scope.answers[id_question[i]] || !scope.answers[id_question[i]].value || (scope.answers[id_question[i]].value === '')) {
                            q.popup_error = true
                            return true
                        }
                    }
                    q.popup_error = false
                    return false
                }
                q.popup_error = false
                return false
            }

            scope.setLandscapeEquipment = function (question, answer) {
                if (answer.pictofont && (question.answer_type === 'equipment')) {
                    const fn = (answer.value) ? 'add' : 'remove'
                    return scope.bubbles[fn](answer.pictofont)
                }
            }

            scope.setLandscapeDone = function (subscription, onLoad) {
                scope.nBubbles = scope.bubbles.getSize()
                let isSubscription = false
                scope.$evalAsync(() => scope.loaded = false)

                if (scope.subscriptionStates.indexOf($state.current.name) > -1) {
                    isSubscription = true
                }

                if (!isSubscription) {
                    return scope.$evalAsync(() => {
                        scope.animTriggered = true
                        const elem = document.getElementById('form-container')
                        const vis = document.getElementById('vis')
                        const landCanvas = document.getElementById('landscape-canvas')
                        if (elem && vis && landCanvas) {
                            elem.className += ' get-out'
                            landCanvas.className += ' get-in-middle'
                            vis.className += 'fade-out'
                        }

                        if (!onLoad) {
                            return $uibModal.open({
                                animation: true,
                                size: 'xs',
                                templateUrl: '/directives/landscape-form/endModal.html',
                                controller($scope, $uibModalInstance) {
                                    return $scope.close = $uibModalInstance.dismiss
                                },
                            })
                        }
                    })
                } else if (isSubscription && scope.$parent.popupInstance) {
                    return $timeout(() => {
                        const canvas = document.getElementById('landscape-canvas')
                        if ((scope.$parent.isEdition !== true) && (scope.$parent.isNew !== true) && (scope.landscapeOpened === true) && (scope.landscapeIsDone !== true)) {
                            scope.$parent.isEdition = false
                            scope.$parent.isNew = false
                            return scope.$parent.$close({
                                answers: scope.answers,
                                canvas,
                                landscapeDone: true,
                                LandscapeElements: LandscapeElements.LandscapeElements,
                                heating: scope.heating,
                                primary_residence: scope.primary_residence,
                            })
                        } else if ((scope.landscapeDonePassed === true) && (scope.landscapeIsDone === true)) {
                            scope.$parent.isEdition = false
                            scope.$parent.isNew = false
                            return scope.$parent.$close({
                                answers: scope.answers,
                                canvas,
                                landscapeDone: true,
                                LandscapeElements: LandscapeElements.LandscapeElements,
                                heating: scope.heating,
                                primary_residence: scope.primary_residence,
                            })
                        }
                        scope.landscapeDonePassed = true
                        scope.$parent.isEdition = false
                        scope.$parent.isNew = false
                        scope.landscapeOpened = true
                        scope.loaded = true
                        return scope.editForm()
                    }, 1500)
                }
            }

            scope.landscapeDonePassed = false
            scope.landscapeOpened = false

            // temperature
            scope.setTemperatureAnswer = function (temp, q) {
                scope.answers[q.id] = scope.answers[q.id] || {}
                scope.answers[q.id].value = temp.value
                return scope.answers[q.id].answer_func = temp.value
            }

            // temperature
            scope.setTempStyle = function (temp, q) {
                if (scope.answers[q.id] && (scope.answers[q.id].value === temp.value)) {
                    return { background: temp.color, color: 'white' }
                }
                return { background: 'white' }
            }

            // temp tooltip
            scope.setTempTooltipStyle = function (temp, q) {
                if (scope.answers[q.id] && (scope.answers[q.id].value === temp.value)) {
                    return { color: temp.color }
                }
                return {}
            }

            scope.returnCanvas = function () {
                const canvas = document.getElementById('landscape-canvas')
                return scope.$parent.$close({
                    answers: scope.answers,
                    canvas,
                })
            }

            // key binding
            window.addEventListener('keydown', (k) => {
                if (!scope.popup && $('#landscape-popup').hasClass('ng-hide')) {
                    switch (k.keyCode) {
                        case 13: return scope.validateQ(scope.questionsI - 1, 'keydown')
                        default:
                            return null
                    }
                } else {
                    switch (k.keyCode) {
                        case 13: return scope.$evalAsync(() => scope.popup = false)
                        default:
                            return null
                    }
                }
            })



            // drawing
            const watchAnswers = function (answers, oldAnswers) {
                if (answers && answers.length) {
                    let reset = false
                    return (() => {
                        const result = []
                        for (let i = 1, end = answers.length, asc = end >= 1; asc ? i <= end : i >= end; asc ? i++ : i--) {
                            // new answers
                            var nextQ
                            var value
                            let item

                            const question = scope.getQuestionById(i)
                            if (question) { nextQ = scope.getNextQuestion(question) }

                            // if nextQ is array
                            if (nextQ && (typeof (nextQ) === 'object')) {
                                nextQ = nextQ[0]
                            }
                            // ...
                            if (answers[i]) {
                                ({ value } = answers[i])
                                if (question && (question.answer_type === 'equipment')) {
                                    value = answers[i]
                                    scope.setLandscapeEquipment(question, value)
                                }
                            }

                            if (question && (question.answer_type !== 'equipment')) {
                                if (answers[i] && !oldAnswers[i] && question && value) {
                                    item = scope.setLandscapeElement(question, value)
                                } else if (answers[i] && oldAnswers[i] && (value !== oldAnswers[i].value)) {
                                    // answer is set but different
                                    if ((i !== 1) || (!answers[nextQ] && !reset)) {
                                        item = scope.setLandscapeElement(question, value)
                                    } else if (!reset) {
                                        scope.setLandscapeElement(question, value)
                                        item = reset = true
                                    } else if (reset) {
                                        item = scope.setLandscapeElement(question, null)
                                    }
                                } else if (answers[i] && oldAnswers[i] && (value === oldAnswers[i].value)) {
                                    if (reset) {
                                        scope.setLandscapeElement(question, null)
                                        item = answers[i] = null
                                    } else {
                                        // set from init
                                        item = scope.setLandscapeElement(question, value)
                                    }
                                }
                            }
                            result.push(item)
                        }
                        return result
                    })()
                }
            }

            scope.$watch('answers', watchAnswers, true)

            // INIT FORM
            const init = function () {
                if (scope.questions) {
                    for (let i = 0, end = scope.questions.length, asc = end >= 0; asc ? i < end : i > end; asc ? i++ : i--) {
                        var l
                        if (scope.questions[i][0]) {
                            scope.questionsI++
                        }

                        if (!scope.questions[i].length) {
                            l = Object.keys(scope.questions[i]).length
                        } else {
                            l = scope.questions[i].length
                        }

                        for (let it = 0, end1 = l, asc1 = end1 >= 0; asc1 ? it < end1 : it > end1; asc1 ? it++ : it--) {
                            // first question check if it has answers, otherwise go to step 0
                            // preventing user to try to enter further step url
                            if ((i === 0) && !scope.questions[i][it].answer && (scope.currentStep !== 1)) {
                                scope.answers = []
                                LandscapeElements.LandscapeElements = []
                                scope.landscapeElements = LandscapeElements.LandscapeElements
                                scope.goToStep(0)
                                break
                            }

                            if (scope.questions[i][it] && scope.questions[i][it].answer) {
                                const qId = scope.questions[i][it].id
                                if (scope.questions[i][it].answer_type === 'equipment') {
                                    var itt
                                    if (typeof scope.questions[i][it].answer === 'string') {
                                        const qA = scope.questions[i][it].answer.split(',')
                                        scope.answers[qId] = {}
                                        for (itt = 0, end2 = qA.length, asc2 = end2 >= 0; asc2 ? itt < end2 : itt > end2; asc2 ? itt++ : itt--) {
                                            var asc2
                                            var end2
                                            const { enums } = scope.questions[i][it]

                                            for (let ittt = 0, end3 = enums.length, asc3 = end3 >= 0; asc3 ? ittt < end3 : ittt > end3; asc3 ? ittt++ : ittt--) {
                                                if (parseInt(enums[ittt].id_equipment, 10) === parseInt(qA[itt], 10)) {
                                                    scope.answers[qId][parseInt(qA[itt], 10)] = { value: true, pictofont: enums[ittt].pictofont, answer_func: enums[ittt].answer_func }
                                                    scope.setLandscapeEquipment(scope.questions[i][it], scope.answers[qId][parseInt(qA[itt], 10)])
                                                }
                                            }
                                        }
                                    } else {
                                        scope.answers[qId][scope.questions[i][it].answer] = {
                                            value: true,
                                            pictofont: scope.questions[i][it].pictofont,
                                            answer_func: scope.questions[i][it].answer_func,
                                        }
                                    }

                                    if (scope.questions[i][it].popups && (scope.questions[i][it].popups.length > 0)) {
                                        for (itt = 0, end4 = scope.questions[i][it].popups.length, asc4 = end4 >= 0; asc4 ? itt < end4 : itt > end4; asc4 ? itt++ : itt--) {
                                            var asc4
                                            var end4
                                            const popup = scope.questions[i][it].popups[itt]
                                            scope.answers[popup.id] = scope.answers[popup.id] || {}
                                            scope.answers[popup.id].value = popup.answer
                                            scope.answers[popup.id].answer_func = popup.answer_func
                                            scope.answers[qId].popups = scope.answers[scope.questions[i][it].id].popups || []
                                            scope.answers[qId].popups[popup.id] = scope.answers[popup.id]
                                        }
                                    }
                                } else if (scope.questions[i][it].answer_type === 'multi') {
                                    scope.answers[scope.questions[i][it].id] = { value: scope.questions[i][it].answer }
                                    const tmpMulti = JSON.parse(scope.questions[i][it].answer)

                                    for (let multiI = 0, end5 = scope.questions[i][it].multi.length, asc5 = end5 >= 0; asc5 ? multiI < end5 : multiI > end5; asc5 ? multiI++ : multiI--) {
                                        scope.questions[i][it].multi[multiI].value = tmpMulti[scope.questions[i][it].multi[multiI].index]
                                    }
                                } else {
                                    scope.answers[scope.questions[i][it].id] = { value: scope.questions[i][it].answer, answer_func: scope.questions[i][it].answer_func }
                                }
                            }

                            if (i === (scope.questions.length - 1)) {
                                if (scope.questions[i][it] && !scope.getNextQuestion(scope.questions[i][it]) && scope.questions[i][it].answer && scope.questions[i][it].last) {
                                    scope.setLandscapeDone(null, true)
                                }

                                if (!scope.questions[i][it].answer && (scope.currentStep !== 1)) {
                                    scope.answers = []
                                    LandscapeElements.LandscapeElements = []
                                    scope.landscapeElements = LandscapeElements.LandscapeElements
                                    scope.goToStep(0)
                                }
                            }
                        }
                    }

                    scope.loaded = true
                    if (scope.questions.length > 1) {
                        scope.goToQ(scope.questions.length - 1)
                    }

                    // Set event listener for transition end
                    scope.isSubscription = false
                    if (scope.subscriptionStates.indexOf($state.current.name) > -1) {
                        scope.isSubscription = true
                    }

                    if (scope.isSubscription) {
                        if (scope.questions && (scope.questions.length > 0)) {
                            scope.landscapeIsDone = ((scope.questions[scope.questions.length - 1][0].last === true) && (scope.questions[scope.questions.length - 1][0].answer !== undefined))
                            $timeout(() => {
                                if ((scope.$parent.isEdition !== true) && (scope.$parent.isNew !== true)) {
                                    return scope.returnCanvas()
                                }
                                scope.$parent.isNew = false
                                scope.$parent.isEdition = false
                                return scope.landscapeOpened = true
                            }, 1000)
                        } else {
                            $timeout(() => scope.returnCanvas())
                        }
                    }

                    const landscapeCanvasEl = $('#landscape-canvas')
                    return landscapeCanvasEl.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', (e) => {
                        if (scope.animTriggered) {
                            if (!scope.landscapeDone) {
                                scope.$apply(() => scope.landscapeDone = true)
                                $timeout(() => {
                                    const loader = document.getElementById('landscape-loader')
                                    return loader.style.display = 'none'
                                }, 300)
                            } else {
                                scope.$apply(() => scope.landscapeDone = false)
                            }

                            return scope.$apply(() => scope.animTriggered = false)
                        }
                    })
                }
            }

            if ((scope.subscriptionStates.indexOf($state.current.name) > -1) && ((scope.$parent.isNew === true) || (scope.$parent.isEdition === true))) {
                return $rootScope.$on('landscapeModalReady', (event, data) => init())
            }
            return init()
        },
    },
}),
)

function __range__(left, right, inclusive) {
    const range = []
    const ascending = left < right
    const end = !inclusive ? right : ascending ? right + 1 : right - 1
    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i)
    }
    return range
}
